import { XCircleIcon } from '@heroicons/react/20/solid';
import React from 'react';

interface ClientContactWarningProps {
  onClick: () => void;
}

export const ClientContactWarning: React.FC<ClientContactWarningProps> = ({
  onClick,
}) => (
  <button
    onClick={onClick}
    onKeyDown={(e) => e.key === 'Enter' && onClick()}
    className="text-[10px] font-semibold text-rose-700 bg-rose-50 px-2 py-0.5 rounded-md hover:bg-rose-100 border border-rose-100 transition-colors flex items-center gap-1 whitespace-nowrap uppercase tracking-wide"
    aria-label="Edit client contact restriction"
    type="button"
  >
    <XCircleIcon className="h-3.5 w-3.5 flex-shrink-0" />
    <span>Do Not Contact Client</span>
  </button>
);
